module.exports = __webpack_public_path__ + "static/media/webdesign-services-img40.ffad462f.jpg";